window.addEventListener("load", function () {
  // Navigation click → slide
  var $navItems = $(".group__right--item[data-slide]");

  $navItems.on("click", function (e) {
    e.preventDefault();
    var index = parseInt($(this).data("slide"), 10);
    if (window.swiper) {
      window.swiper.slideTo(index);
    }
    $navItems.removeClass("active");
    $(this).addClass("active");
  });

  // Sync active nav when swiper changes slide
  if (window.swiper) {
    window.swiper.on("slideChange", function () {
      $navItems.removeClass("active");
      $navItems
        .filter('[data-slide="' + window.swiper.activeIndex + '"]')
        .addClass("active");
    });
  }

  var $musicBtn = $(".group__right--music");
  var audioSrc = $("#MS__wrapper").data("audio");
  if (!audioSrc || !$musicBtn.length) return;

  var audio = new Audio(audioSrc);
  audio.loop = true;

  // Chờ user tương tác lần đầu vào trang → play nhạc
  function playOnFirstInteraction() {
    audio.play().then(function () {
      $musicBtn.removeClass("off");
    });
    document.removeEventListener("click", playOnFirstInteraction, true);
    document.removeEventListener("touchstart", playOnFirstInteraction, true);
  }

  // Thử autoplay, nếu bị chặn thì chờ interaction đầu tiên
  audio
    .play()
    .then(function () {
      $musicBtn.removeClass("off");
    })
    .catch(function () {
      $musicBtn.addClass("off");
      document.addEventListener("click", playOnFirstInteraction, true);
      document.addEventListener("touchstart", playOnFirstInteraction, true);
    });

  $musicBtn.on("click", function (e) {
    e.preventDefault();
    if (audio.paused) {
      audio.play();
      $musicBtn.removeClass("off");
    } else {
      audio.pause();
      $musicBtn.addClass("off");
    }
  });
});
